import React from 'react';
import { Box } from '@mui/material';

import { TestDTO, TestSessionSummaryDTO } from '@/api/generated';
import CompleteIcon from '@/assets/icons/status-complete.svg?react';
import InProgressIcon from '@/assets/icons/status-in-progress.svg?react';
import IsRetestIcon from '@/assets/icons/status-is-repeat.svg?react';
import IsRefusedIcon from '@/assets/icons/status-refused.svg?react';
import RegisteredIcon from '@/assets/icons/status-registered.svg?react';
import { getTestSessionIconStyles, isComplete, isInProgress, isRefused, isRetest } from '@/utils/testSessions';

const size = 16;

const TestSessionProgressIcon = ({ testSession }: { testSession: TestDTO & TestSessionSummaryDTO }) => {
  let icon = <RegisteredIcon width={size} height={size} display="block" />;

  if (isRefused(testSession)) icon = <IsRefusedIcon width={size} height={size} display="block" />;
  else if (isRetest(testSession)) icon = <IsRetestIcon width={size} height={size} display="block" />;
  else if (isComplete(testSession)) icon = <CompleteIcon width={size} height={size} display="block" />;
  else if (isInProgress(testSession)) icon = <InProgressIcon width={size} height={size} display="block" />;

  return <Box sx={getTestSessionIconStyles()}>{icon}</Box>;
};

export default TestSessionProgressIcon;
